import { jsx } from "react/jsx-runtime";
import { iconFactory } from "./Icon.js";
const IconTooltip = iconFactory('IconTooltip', /*#__PURE__*/ jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-icon-type": "fill",
    children: /*#__PURE__*/ jsx("path", {
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8ZM14 12V18H10V12H14Z"
    })
}));
export { IconTooltip };
